export default __webpack_public_path__ + "static/media/ic-error.ec176f2e.svg";